import React, { useState, useEffect, ReactNode } from "react";
import { Statement } from "../../firebase/statements";
import { Hidden } from "@material-ui/core";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";
import { storage } from "../../firebase/firebase";
import DefaultBackgroundImage from "./svg/background-yellow.svg";

const storageFolder = "statements";

interface Props {
  statement: Statement;
  titleIsLink?: boolean;
  statementNavigation: ReactNode;
}

export default function StatementHeader({
  statement,
  titleIsLink = false,
  statementNavigation,
}: Props) {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState<string | null>(
    null
  );

  const props = {
    statement,
    statementNavigation,
    titleIsLink: titleIsLink ? titleIsLink : false,
    backgroundImageUrl: backgroundImageUrl || DefaultBackgroundImage,
  };

  useEffect(() => {
    async function determineBackgroundUrl() {
      try {
        const firebaseUrl = await storage
          .ref(storageFolder)
          .child(statement.id)
          .getDownloadURL();
        setBackgroundImageUrl(firebaseUrl);
      } catch {
        setBackgroundImageUrl(null);
      }
    }
    determineBackgroundUrl();
  }, [statement]);

  return (
    <>
      <Hidden mdUp>
        <HeaderMobile {...props} />
      </Hidden>

      <Hidden smDown>
        <HeaderDesktop {...props} />
      </Hidden>
    </>
  );
}
